import { Box, Container } from "@mui/material";
import SectionHeader from "./SectionHeader";
import { UI } from "../../config/site";

export default function Section({
  id,
  header,
  children,
  bgcolor = "background.default",
  maxWidth = UI.containerMaxWidth,
  py = { xs: 6, md: 10 },
}) {
  return (
    <Box
      id={id}
      sx={{
        py,
        scrollMarginTop: { xs: `${UI.toolbar.xs}px`, md: `${UI.toolbar.md}px` },
        bgcolor,
      }}
    >
      <Container maxWidth={maxWidth}>
        {header && <SectionHeader {...header} />}
        {children}
      </Container>
    </Box>
  );
}
